import { UserDictionaryApi } from 'src/api/userDictionary';
import { SingleLearnableStat } from 'src/api/userDictionary/schema';

export interface BulkActionOptions {
  languagePairId: number;
  wordIds: number[];
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

/**
 * Marks multiple learnables as known in a single API call
 */
export const bulkMarkAsKnown = async ({
  languagePairId,
  wordIds,
  onSuccess,
  onError,
}: BulkActionOptions): Promise<void> => {
  try {
    const learnables: SingleLearnableStat[] = wordIds.map(id => ({
      learnable_key: id,
      known: true,
    }));

    await UserDictionaryApi.updateLearnables(languagePairId, { learnables });

    onSuccess?.();
  } catch (error) {
    onError?.(error);
    throw error;
  }
};

/**
 * Unmarks multiple learnables as known in a single API call
 */
export const bulkUnmarkAsKnown = async ({
  languagePairId,
  wordIds,
  onSuccess,
  onError,
}: BulkActionOptions): Promise<void> => {
  try {
    const learnables: SingleLearnableStat[] = wordIds.map(id => ({
      learnable_key: id,
      known: false,
      reset_growth_level: true,
    }));

    await UserDictionaryApi.updateLearnables(languagePairId, { learnables });

    onSuccess?.();
  } catch (error) {
    onError?.(error);
    throw error;
  }
};
